import { getDefaultState } from '@/store/modules/plan/state'

export const RESET_STATE = 'RESET_STATE'
export const SET_BASE_ON_PRICE = 'SET_BASE_ON_PRICE'
export const SET_PLAN_DETAIL = 'SET_PLAN_DETAIL'
export const SET_CUSTOMER_PLAN = 'SET_CUSTOMER_PLAN'
export const SET_USE_COUPON = 'SET_USE_COUPON'
export const SET_USE_BENEPO_POINT = 'SET_USE_BENEPO_POINT'
export const SET_ORDER = 'SET_ORDER'
export const SET_CANCEL_ORDER = 'SET_CANCEL_ORDER'
export const SET_POINT = 'SET_POINT'
export const SET_SCROLL_CALENDAR = 'SET_SCROLL_CALENDAR'

export default {
  [RESET_STATE](state) {
    Object.assign(state, getDefaultState())
  },
  [SET_BASE_ON_PRICE](state, payload) {
    state.baseOnPrice = payload
  },
  [SET_PLAN_DETAIL](state, payload) {
    state.planDetail = payload
  },
  [SET_CUSTOMER_PLAN](state, payload) {
    state.customerPlan = payload
  },
  [SET_USE_COUPON](state, payload) {
    state.isUseCoupon = payload
  },
  [SET_USE_BENEPO_POINT](state, payload) {
    state.isUseBenepoPoint = payload
  },
  [SET_ORDER](state, payload) {
    state.orderDetail = payload
  },
  [SET_CANCEL_ORDER](state, payload) {
    state.orderDetail = payload
  },
  [SET_POINT](state, payload) {
    state.pointRemain = payload
  },
  [SET_SCROLL_CALENDAR](state, payload) {
    state.scrollCalendar = payload
  }
}